<template>
  <div>
    <company-information-form
      :titles="local.foreignCompanyData"
      :form-model="formModel"
      :required="required"
      :validation-required="false"
      is-commercial-registration-number-of-type-text
      :allow-commercial-registration-number="true"
      :is-view-mode="isViewMode"
    ></company-information-form>

    <company-manager-form
      :title="local.foreignCompanyData.managerTitle"
      :form-model="formModel"
      :required="required"
      :show-needs-translator-form="true"
      :is-view-mode="isViewMode"
    ></company-manager-form>

    <naj-address
      :title="local.titleHeader.addressCorporation"
      :form-model="formModel.placeAddress"
      :required="required"
      :is-view-mode="isViewMode"
    ></naj-address>
  </div>
</template>

<script>
import CompanyInformationForm from './forms/company-information-form';
import CompanyManagerForm from './forms/company-manager-form';
import { partyTypeEnum } from '@/helpers/enum.js';

export default {
  inject: ['$validator'],
  components: {
    CompanyInformationForm,
    CompanyManagerForm,
  },
  props: ['formModel', 'required', 'isViewMode'],
  data() {
    return { partyTypeEnum };
  },
};
</script>
